export enum CustomAttributeType {
    BOOLEAN = 'BOOLEAN',
    AMOUNT = 'AMOUNT',
}
